//#region
import axios from 'axios'
import { url, endPoint } from '../urls'
//#endregion

export const getMeasuresListWithCancelToken = (params) => {
  let _url = url.backendHost + endPoint.measures.getMeasuresList
  let cancelToken = axios.CancelToken.source();
  return [cancelToken, () => axios.get(_url, { cancelToken: cancelToken.token, params })]
}

export const getMeasuresList = (params) => {
  let _url = url.backendHost + endPoint.measures.getMeasuresList
  return axios.get(_url, { params })
}

export const getMeasuresLists = (params) => {
  let _url = url.backendHost + endPoint.measures.getMeasuresList
  return axios.post(_url, params )
}

export const getAllMeasuresList = (params) => {
  let _url = url.backendHost + endPoint.measures.getAllMeasuresList
  return axios.get(_url, { params })
}

export const getMeasuresByDataset = (params) => {
  let _url = url.backendHost + endPoint.measures.getMeasures
  return axios.get(_url, params)
}

export const addMeasures = (params) => {
  let _url = url.backendHost + endPoint.measures.addMeasures
  return axios.post(_url, params)
}

export const updateMeasure = (params) => {
  let _url = url.backendHost + endPoint.measures.updateMeasure
  return axios.put(_url, params)
}

export const deleteMeasure = (params) => {
  let _url = url.backendHost + endPoint.measures.deleteMeasure
  return axios.put(_url, params)
}

export const getMeasureById = (params) => {
  let _url = url.backendHost + endPoint.measures.getMeasureById
  return axios.get(_url, { params })
}

export const findMeasureByNameAndDataSetId = (params) => {
  let _url = url.backendHost + endPoint.measures.findMeasureByNameAndDataSetId
  return axios.get(_url, { params })
}

export const deleteMeasureByName = (params) => {
  let _url = url.backendHost + endPoint.measures.deleteMeasureByName
  return axios.put(_url, params)
}

export const hideMeasure = (params) => {
  let _url = url.backendHost + endPoint.measures.hideMeasure
  return axios.put(_url, params)

}

export const getMeasuresListOnSelect = (params) => {
  let _url = url.backendHost + endPoint.measures.getMeasuresListOnSelect
  return axios.get(_url, { params })
}
